<template>
  <div class="header">
    <div class="ct-header">
      <div class="header-inner-box clearfix">
        <div class="inner-left-box flex-box" @click="back">
          <div class="back-box">
            <div class="back-btn" v-if="showBack">
              <img src="@/assets/home/left1.png" alt="" class="back-icon-btn" />
            </div>
            <div class="title">{{ headerTitle }}</div>
          </div>
        </div>
        <div class="header-right-box">
         
          <div class="header-item">
            <img src="@/assets/home/jinbi.png" style="height: 24px;width:auto;margin-right: 10px;" alt="">
            <div class="numer">
              {{ data.accountAmount || '0.00' }}
            </div>
          </div>
          <div class="header-item">
            <img src="@/assets/home/jifen.png" style="height: 22px;width:auto;margin-right: 4px;" alt="">
            <div class="numer">
              {{ data.accountCredits || '0.00' }}
            </div>
          </div>
        </div>
        <!-- <div class="inner-right-box">
          <div class="balance balance-1" v-if="showBalanceOne">
            <img src="../../src/assets/images/balance.png" />
            <div class="digit-div digit-div">
              <div v-for="(num, index) in (data.accountCredits || '0.00') + ''" :index="index"
                :class="[num == '.' ? 'code_11 no-num' : 'code_' + num]" class="num-data offset_0"
                style="transform: scale(1); transform-origin: center center 0px"></div>
            </div>
          </div>
          <div class="balance balance-2" v-if="showBalanceTwo">
            <img src="../../src/assets/images/balance1.png" />
            <div class="digit-div digit-div">
              <div v-for="(num, index) in (data.accountAmount || '0.00') + ''" :index="index"
                :class="[num == '.' ? 'code_11 no-num' : 'code_' + num]" class="num-data offset_0"
                style="transform: scale(1); transform-origin: center center 0px"></div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, logOut } from "@/api/index";
import { removeToken } from "@/api/cookie";
import { mapState } from "vuex";

import store from "@/vuex/store";

export default {
  name: "otherHeaderTop",
  data() {
    return {
      user: {},
      sliderbtn: false,
      show: true,
      data: {},
    };
  },

  computed: {
    ...mapState(["login_top", "LOGIN_IS_SHOW"]),
  },
  mounted() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "USER_INFO") {
        // console.log(mutation);
        // console.log(state.USER_INFO);
        this.data = state.USER_INFO;
      }
    });

    this.getInfo();
    this.$bus.$on("islogin", (data) => {
      this.show = data;
      console.log(data);
      if (data == false) {
        getUserInfo().then((res) => {
          this.user = res.data.data;
        });
      }
    });
    this.changestore();
  },
  methods: {
    // 退出清空数据
    clearData() {
      this.data = {};
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    changestore() {
      if (this.$store.showstate) {
        this.sliderbtn = this.$store.showstate;
      }
    },
    hd() {
      this.$store.commit("LOGIN_IS_SHOW", false);
    },
    hd2() {
      this.$store.commit("LOGIN_IS_SHOW", true);
    },
    handleindex() {
      this.$router.push("/");
    },
    hdtc() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.$socket.send("logout_userId_" + res.data.data.userId);
          logOut().then((res) => {
            if (res.data.code == 200) {
              this.$router.push("/");
              this.$bus.$emit("close", true);

              removeToken();
              this.show = true;
            }
          });
        }
      });
    },
    handleOpen() {
      this.sliderbtn = !this.sliderbtn;
      this.$bus.$emit("sliderbtn", this.sliderbtn);
    },
    handleLog() {
      // this.$bus.$emit("close", true);
      this.$router.push("/login");
      this.$soundPlay("click");
    },
    getInfo() {
      getUserInfo().then((res) => {
        console.log("获取用户数据", res);
        this.user = res.data.data;
        if (res.data.code == 200) {
          this.$store.commit("USER_INFO", res.data.data);
          store.subscribe((mutation, state) => {
            if (mutation.type === "USER_INFO") {
              console.log(mutation);
              console.log(state.USER_INFO);
              this.data = state.USER_INFO;
            }
          });
        } else {
          this.$store.commit("LOGIN_IS_SHOW", true);
        }
      });
    },
    back() {
      if (this.showBack) {
        this.$emit("back");
      }
    },
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    headerTitle: {
      type: String,
      default: "",
    },

    showBalanceOne: {
      type: Boolean,
      default: true,
    },
    showBalanceTwo: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的代码
.ct-header {
  --head-height: 58.8px;
  width: 100 * 4.2px;
  height: var(--head-height);
  background: url("../assets/home/top.png") no-repeat 0 0;
  background-size: 100% var(--head-height);
  position: relative;
  z-index: 98;
  top: 0;
  left: 0;
}

.ct-header.app-header {
  background: url("../assets/images/app_header.png") no-repeat 0 0;
  background-size: 100 * 4.2px var(--head-height);
}

// .ct-header::before {
//   content: "";
//   width: 9.87 * 4.2px;
//   height: 2.8 * 4.2px;
//   background: url("../assets/images/line.png") no-repeat 0 0;
//   background-size: 9.87 * 4.2px 2.8 * 4.2px;
//   position: absolute;
//   bottom: 0;
//   left: 2.4 * 4.2px;
// }

.ct-header.line-position::before {
  left: 4 * 4.2px;
}

.ct-header .header-inner-box {
  width: 100 * 4.2px;
  height: 10.67 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 1.33 * 4.2px;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.ct-header .inner-left-box {
  // width: 40 * 4.2px;
  height: 10.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding-left: 2.67 * 4.2px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
}

.ct-header .inner-left-box .avatar {
  position: relative;
  width: 9.6 * 4.2px;
  height: 9.6 * 4.2px;
}

.ct-header .inner-left-box .avatar img {
  width: 9.33 * 4.2px;
  height: 9.33 * 4.2px;
  -webkit-border-radius: 4 * 4.2px;
  border-radius: 4 * 4.2px;
  overflow: hidden;
}

.ct-header .inner-left-box .avatar .vip-logo {
  z-index: 1;
  position: absolute;
  left: 0px;
  bottom: -2 * 4.2px;
  width: 9.6 * 4.2px;
  height: 4.53 * 4.2px;
}

.ct-header .inner-left-box .avatar .vip-logo.vip-anim {
  -webkit-animation: vipLogoKf01 0.32s linear 0s 1;
  animation: vipLogoKf01 0.32s linear 0s 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0;
}

@-webkit-keyframes vipLogoKf01 {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes vipLogoKf01 {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.ct-header .inner-left-box .avatar:after {
  content: "";
  display: block;
  width: 9.6 * 4.2px;
  height: 9.6 * 4.2px;
  background: url("../assets/images/head_bk.png") no-repeat 0 0;
  background-size: 9.6 * 4.2px 9.6 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.ct-header .inner-left-box .logo-name {
  width: 26.93 * 4.2px;
  height: 11.6 * 4.2px;
  background-image: url("../assets/images/login_n.png");
  background-size: 100% 100%;
}

.ct-header .inner-left-box .user-info {
  font-size: 2.67 * 4.2px;
  padding-left: 2.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ct-header .inner-left-box .user-info .username {
  height: 2.67 * 4.2px;
  line-height: 2.67 * 4.2px;
  color: #a6bbff;
}

.ct-header .inner-left-box .user-info .nickname {
  width: 26.67 * 4.2px;
  height: 2.67 * 4.2px;
  line-height: 2.67 * 4.2px;
  color: #c7d4ff;
  margin-top: 0.67 * 4.2px;
}

.ct-header .inner-left-box .home-user-info {
  margin-left: 1.47 * 4.2px;
  width: 24 * 4.2px;
}

.ct-header .inner-left-box .home-user-info .nickname {
  font-size: 2.67 * 4.2px;
  font-weight: normal;
  color: #ffffff;
  letter-spacing: 1px;
}

.ct-header .inner-left-box .home-user-info .username {
  font-size: 2.27 * 4.2px;
  font-weight: normal;
  color: #d4d4ff;
  background: url("../assets/images/bars.png") no-repeat 0 0;
  background-size: 22.67 * 4.2px 3.33 * 4.2px;
  text-align: left;
}

.ct-header .inner-left-box .home-user-info .username .label {
  color: #fff;
  padding-left: 1.33 * 4.2px;
  padding-right: 2 * 4.2px;
}

.ct-header .inner-left-box .back-box {
  height: 10.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  // margin-left: 2.67 * 4.2px;
}

.ct-header .inner-left-box .back-box .back-btn {
  // width: 8 * 4.2px;
  height: 10.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  // padding-left: 1.47 * 4.2px;
}

.ct-header .inner-left-box .back-box .back-icon-btn {
  width: 3.6 * 4.2px;
  height: 6.4 * 4.2px;
}

.ct-header .inner-left-box .back-box .title {
  // font-family: "Alimama ShuHeiTi", serif;
  font-size: 16px;
  color: #ffffff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-weight: 700;
}

.ct-header .inner-right-box {
  height: 10.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  right: 2.67 * 4.2px;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.ct-header .inner-right-box .balance {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.ct-header .inner-right-box .balance-1 {
  margin-right: 3.47 * 4.2px;
}

.ct-header .inner-right-box .balance-1 img {
  width: 8.13 * 4.2px;
  height: 8.13 * 4.2px;
}

.ct-header .inner-right-box .balance-2 img {
  width: 7.6 * 4.2px;
  height: 7.07 * 4.2px;
}

.ct-header .inner-right-box .balance-2 .add-icon {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin-left: 0.67 * 4.2px;
}

// .ct-header .inner-right-box .need-login {
//   width: 28.67 * 4.2px;
//   height: 8.4 * 4.2px;
//   background: url("../assets/images/login_register.png") no-repeat center center / 80.64px 24px,
//     url("../assets/images/need_login1.png") no-repeat center center / 100% 100%;
// }

.appFont {
  font-family: appFont;
}

.header-right-box {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  // z-index: 99999;

  .header-item {
    display: flex;
    align-items: center;
    // padding: 0 14px;
    width: 50%;
    flex-shrink: 0;
    margin-right: 4px;
    color: #C6DAFF;

    &:last-child {
      margin-right: 0;
    }

    .numer {
      margin-bottom: 2px;
    }
  }
}

.ct-header .inner-left-box .back-box{
  width: 130px;
  padding-left: 10px;
}

.ct-header .inner-left-box .back-box .back-icon-btn {
  width: 5.7 * 4.2px;
  height: 5.7 * 4.2px;
}

@media only screen and (max-width: 430px) {
  .ct-header {
    width: 100vw;
    // position: fixed;
  }

  .ct-header.app-header {
    background-size: 100vw var(--head-height);
  }

  // .ct-header::before {
  //   content: "";
  //   width: 9.87vw;
  //   height: 2.8vw;

  //   left: 2.4vw;
  // }

  .ct-header.line-position::before {
    left: 4vw;
  }

  .ct-header .header-inner-box {
    width: 100%;
    height: 10.67vw;

    bottom: 1.33vw;
  }

  .ct-header .inner-left-box {
    width: 40vw;
    height: 10.67vw;
  }

  .ct-header .inner-left-box .avatar {
    position: relative;
    width: 9.6vw;
    height: 9.6vw;
  }

  .ct-header .inner-left-box .avatar img {
    width: 9.33vw;
    height: 9.33vw;
    -webkit-border-radius: 4vw;
    border-radius: 4vw;
  }

  .ct-header .inner-left-box .avatar .vip-logo {
    left: 0px;
    bottom: -2vw;
    width: 9.6vw;
    height: 4.53vw;
  }

  .ct-header .inner-left-box .avatar:after {
    width: 9.6vw;
    height: 9.6vw;

    background-size: 9.6vw 9.6vw;
  }

  .ct-header .inner-left-box .logo-name {
    width: 26.93vw;
    height: 11.6vw;
  }

  .ct-header .inner-left-box .user-info {
    font-size: 2.67vw;
    padding-left: 2.27vw;
  }

  .ct-header .inner-left-box .user-info .username {
    height: 2.67vw;
    line-height: 2.67vw;
  }

  .ct-header .inner-left-box .user-info .nickname {
    width: 26.67vw;
    height: 2.67vw;
    line-height: 2.67vw;

    margin-top: 0.67vw;
  }

  .ct-header .inner-left-box .home-user-info {
    margin-left: 1.47vw;
    width: 24vw;
  }

  .ct-header .inner-left-box .home-user-info .nickname {
    font-size: 2.67vw;

    letter-spacing: 1px;
  }

  .ct-header .inner-left-box .home-user-info .username {
    font-size: 2.27vw;

    background-size: 22.67vw 3.33vw;
  }

  .ct-header .inner-left-box .home-user-info .username .label {
    padding-left: 1.33vw;
    padding-right: 2vw;
  }

  .ct-header .inner-left-box .back-box {
    height: 10.67vw;

    // margin-left: 2.67vw;
  }

  .ct-header .inner-left-box .back-box .back-btn {
    width: 8vw;
    height: 10.67vw;

    // padding-left: 1.47vw;
  }

  .ct-header .inner-left-box .back-box .back-icon-btn {
    width: 5.7 * 4.2px;
    height: 5.7 * 4.2px;
  }

  .header-right-box {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    // z-index: 99999;

    .header-item {
      display: flex;
      align-items: center;
      // padding: 0 14px;
      width: 50%;
      flex-shrink: 0;
      margin-right: 4px;
      color: #C6DAFF;

      &:last-child {
        margin-right: 0;
      }

      .numer {
        margin-bottom: 2px;
      }
    }
  }

  .ct-header .inner-right-box {
    height: 10.67vw;

    right: 2.67vw;


  }

  .ct-header .inner-right-box .balance-1 {
    margin-right: 3.47vw;
  }

  .ct-header .inner-right-box .balance-1 img {
    width: 8.13vw;
    height: 8.13vw;
  }

  .ct-header .inner-right-box .balance-2 img {
    width: 7.6vw;
    height: 7.07vw;
  }

  .ct-header .inner-right-box .balance-2 .add-icon {
    width: 5.33vw;
    height: 5.33vw;
    margin-left: 0.67vw;
  }

  .ct-header .inner-right-box .need-login {
    width: 28.67vw;
    height: 8.4vw;
  }
}
</style>